if (!customElements.get('buy-button')) {
  class BuyButton extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
      this.handleUpdateRef = this.handleUpdate.bind(this);
    }

    handleUpdate(event) {
      this.toggleAttribute('disabled', !event.detail.variant.available);
    }

    handleClick(event) {
      event.preventDefault();

      const form = this.closest('form');
      if (!form) return;

      const id = form.querySelector('[name="id"]')?.value;
      if (!id) return;

      const quantity = form.querySelector('[name="quantity"]')?.value || 1;

      const url = this.getAttribute('js-url');
      if (!url) return;

      window.location.href = url
        .replace('[id]', id)
        .replace('[quantity]', quantity);
    }

    disconnectedCallback() {
      this.addEventListener('click', this.handleClickRef);

      document.removeEventListener('buy-button:update', this.handleUpdateRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);

      document.addEventListener('buy-button:update', this.handleUpdateRef);
    }
  }

  customElements.define('buy-button', BuyButton);
}
